import * as React from 'react';
export const wiseSvg = React.forwardRef(function wiseSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#9EE56F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.427 12.222 6.05 18.534h9.6l1.08-2.977h-4.114l2.514-2.92.008-.077-1.635-2.826h7.354l-5.7 15.754h3.9L25.94 6.5H8.157l3.268 5.722h.002Z',
      fill: '#163300',
    }),
  );
});
wiseSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wise = {
  category: 'brand',
  colorable: false,
  name: 'wise',
  svg: wiseSvg,
};
